import { EventsChannel } from "./EventsChannel";
export class EventsChannelFactory {
    constructor(realTimeService) {
        this.realTimeService = realTimeService;
    }
    createEventsChannel(channelPrefix) {
        return new EventsChannel(this.realTimeService, channelPrefix);
    }
}
